/**
 * https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-A29-v2_1.html
 * @type {KokudoYouto}
 * 用途地域
 */
module.exports = class KokudoYouto {
  a29_001 = null // 行政区域コード
  a29_002 = null // 都道府県名
  a29_003 = null // 市区町村名
  a29_004 = null // 用途地域コード
  a29_005 = null // 用途地域名
  a29_006 = null // 建蔽率
  a29_007 = null // 容積率
  a29_008 = null // 備考
  a29_009 = null
  a29_010 = null

  unknownValue = '9999'

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * @param attributes
   */
  setAttributes(attributes) {
    this.a29_001 = attributes['a29_001'] ?? '-';
    this.a29_002 = attributes['a29_002'] ?? '-';
    this.a29_003 = attributes['a29_003'] ?? '-';
    this.a29_004 = attributes['a29_004'] ?? '-';
    this.a29_005 = attributes['a29_005'] ?? '-';
    this.a29_006 = attributes['a29_006'] ?? '-'; // 不明の時は'9999'とする
    this.a29_007 = attributes['a29_007'] ?? '-'; // 不明の時は'9999'とする
    this.a29_008 = attributes['a29_008'] ?? '-';
    this.a29_009 = attributes['a29_009'] ?? '-';
    this.a29_010 = attributes['a29_010'] ?? '-';
  }

  /**
   * To display table
   */
  toDisplay() {
    const a29_003 = this.a29_003 ?? '';
    return [
      {
        title  : '地域',
        content: (this.a29_002 ?? '') + (a29_003 === '-' ? '' : a29_003),
      },
      {
        title  : '用途地域',
        content: this.a29_005 ?? '',
      },
      {
        title  : '建ぺい率(%)',
        content: this.a29_006 === this.unknownValue ? '' : (this.a29_006 ?? ''),
      },
      {
        title  : '容積率(%)',
        content: this.a29_007 === this.unknownValue ? '' : (this.a29_007 ?? ''),
      },
    ];
  }
}
